import { MMButton } from '@components/index'
import cn from '@integrations/classnames'
import { type ReactNode, useContext } from '@integrations/react'
import { GlobalContext, tr } from 'mmfintech-commons'
import styles from './ConfirmationModal.module.scss'

interface Props {
  title?: string
  question: ReactNode
  onConfirm?: () => void
  confirmCaption?: string
  onClose?: () => void
}

function ConfirmationModal({ title, question, onConfirm, confirmCaption, onClose }: Props) {
  const { modalHide } = useContext(GlobalContext)

  function handleConfirm() {
    modalHide()
    onConfirm?.()
  }

  return (
    <div
      className={cn(styles['confirmation-modal-wrapper'], 'confirmation-modal-wrapper')}
      data-test='confirmation-dialog-modal'
    >
      <div
        className={cn(
          styles['confirmation-modal-container'],
          'confirmation-modal-container',
          'modal-frame-surface',
          'raised-frame-surface',
          'shadow-card'
        )}
      >
        <div className={cn(styles['confirmation-modal-content'], 'confirmation-modal-content')}>
          <div className={cn(styles['heading'], 'heading')}>{title}</div>
          <div>{question}</div>
        </div>

        <MMButton
          type='button'
          variant='primary'
          caption={confirmCaption ?? tr('FRONTEND.BUTTONS.CONFIRM', 'Confirm')}
          onClick={handleConfirm}
          fullWidth
          data-test='button-confirm'
        />
        {Boolean(onClose) && (
          <MMButton
            type='button'
            variant='secondary'
            caption={tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')}
            onClick={onClose}
            className={cn('mt-2')}
            fullWidth
            data-test='button-cancel'
          />
        )}
      </div>
    </div>
  )
}

export default ConfirmationModal
